function Accordion (parent, opts) {
  if (typeof parent !== 'object') { return; }
  var _ = this;

  opts = opts || {}
  _.$parent = parent;
  _.$items = [];
  _.itemIndexOpen = null;
  _.itemElementOpen = null;

  _.options = {
    itemSelector: (typeof opts.itemSelector === 'string') ? opts.itemSelector : '.accordion__item',
    itemContentSelector: (typeof opts.itemContentSelector === 'string') ? opts.itemContentSelector : '.accordion__container',
    itemButtonSelector: (typeof opts.itemButtonSelector === 'string') ? opts.itemButtonSelector : '.accordion__btn',
    itemOpenOnStart: (typeof opts.itemOpenOnStart === 'number') ? opts.itemOpenOnStart : null,
    canAllClose: (typeof opts.canAllClose === 'boolean') ? opts.canAllClose : true,
    autoClose: (typeof opts.autoClose === 'boolean') ? opts.autoClose : true,
    speed: (typeof opts.speed === 'number') ? opts.speed : 400,
    onInit: (typeof opts.onInit === 'function') ? opts.onInit : function() {},
    onOpen: (typeof opts.onOpen === 'function') ? opts.onOpen : function() {},
  }

  if (_.$items.length === 0) {
    _.$items = _.$parent.find(_.options.itemSelector);
  }

  if (_.$items.length) {

    _.$items.each(function(i, el) {
      var $this = $(el);
      if (i === _.options.itemOpenOnStart) {
        $this.addClass('is-open');
        return true;
      }
      $this.addClass('is-close');
      $this.find(_.options.itemContentSelector).css('display', 'none');
    });

    _.$items.each(function(i, el) {
      var $this = $(el);

      $this.find(_.options.itemButtonSelector).on('click', function(e) {

        if ($this.find(_.options.itemContentSelector).is(':visible')) {
          if (_.options.canAllClose) {
            $this.find(_.options.itemContentSelector).slideUp(_.options.speed, function() {
              $(this).closest(_.options.itemSelector).removeClass('is-open').addClass('is-close');
            });
          }
          return true;
        }

        if (_.options.autoClose) {
          _.$parent.find(_.options.itemContentSelector).slideUp(_.options.speed, function() {
            $(this).closest(_.options.itemSelector).removeClass('is-open').addClass('is-close');
          });
        }

        $this.find(_.options.itemContentSelector).slideDown(_.options.speed, function() {
          $(this).closest(_.options.itemSelector).removeClass('is-close').addClass('is-open');
        });
        _.itemElementOpen = $this;
        _.itemIndexOpen = _.$items.index($this);

        _.options.onOpen(_, _.itemElementOpen);
      });
    });

    _.$parent.addClass('accordion-is-enabled');
    _.options.onInit(_);
  }

  return _;
}
